let teamTargetsRequestSeq = 0
let teamTargetsAbortController = null

export const actions = {
  async fetchLatestExpertResponses({ commit }, { page = 1 } = {}) {
    commit('SET_LATEST_EXPERT_RESPONSES_LOADING', true)
    commit('CLEAR_LATEST_EXPERT_RESPONSES_ERROR')
    
    try {
      const response = await axios.get('/api/dashboard/latest-expert-responses', {
        params: { page }
      })
      
      commit('SET_LATEST_EXPERT_RESPONSES_DATA', {
        data: response.data.data,
        pagination: response.data.pagination
      })
      
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch latest expert responses'
      commit('SET_LATEST_EXPERT_RESPONSES_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LATEST_EXPERT_RESPONSES_LOADING', false)
    }
  },

  async fetchLatestClientContacts({ commit }, { page = 1 } = {}) {
    commit('SET_LATEST_CLIENT_CONTACTS_LOADING', true)
    commit('CLEAR_LATEST_CLIENT_CONTACTS_ERROR')

    try {
      const response = await axios.get('/admin/dashboard', {
        params: { page },
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      commit('SET_LATEST_CLIENT_CONTACTS_DATA', {
        data: response.data.data,
        pagination: response.data.pagination
      })

      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch latest client contacts'
      commit('SET_LATEST_CLIENT_CONTACTS_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_LATEST_CLIENT_CONTACTS_LOADING', false)
    }
  },

  async fetchStaffTargets({ commit }, { date = null } = {}) {
    commit('SET_STAFF_TARGETS_LOADING', true)
    commit('CLEAR_STAFF_TARGETS_ERROR')

    try {
      const response = await axios.get('/api/dashboard/staff-targets', {
        params: date ? { date } : {}
      })

      commit('SET_STAFF_TARGETS_DATA', response.data.data)

      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch staff targets'
      commit('SET_STAFF_TARGETS_ERROR', errorMessage)
      throw error
    } finally {
      commit('SET_STAFF_TARGETS_LOADING', false)
    }
  },

  async fetchTeamTargets({ commit }, { from = null, to = null } = {}) {
    const seq = ++teamTargetsRequestSeq
    if (teamTargetsAbortController) {
      teamTargetsAbortController.abort()
    }
    const controller = new AbortController()
    teamTargetsAbortController = controller

    commit('SET_TEAM_TARGETS_LOADING', true)
    commit('CLEAR_TEAM_TARGETS_ERROR')

    const isStale = (error) => seq !== teamTargetsRequestSeq ||
      (error && (axios.isCancel(error) || error.code === 'ERR_CANCELED'))

    try {
      const response = await axios.get('/api/dashboard/staff-targets/team', {
        params: (from && to) ? { from, to } : {},
        signal: controller.signal
      })

      if (seq !== teamTargetsRequestSeq) {
        return undefined
      }

      commit('SET_TEAM_TARGETS_DATA', response.data.data)

      return response.data
    } catch (error) {
      if (isStale(error)) {
        return undefined
      }
      const errorMessage = error.response?.data?.message || 'Failed to fetch team targets'
      commit('SET_TEAM_TARGETS_ERROR', errorMessage)
      throw error
    } finally {
      if (seq === teamTargetsRequestSeq) {
        commit('SET_TEAM_TARGETS_LOADING', false)
      }
    }
  }
}
